<template>
  <div class="description-image">
    <div
      :class="[
        'info-box',
        { 'info-box--dragged-over-drop': isDraggedOverDrop },
      ]"
    >
      <div v-if="hasErrors" class="info-box__error">
        <img
          src="@/assets/img/error_x_mark.svg"
          class="info-box__error-image"
          alt="error icon"
        />
        <div
          v-if="errors.extension"
          v-sanitize-html="$t('image.ERROR_EXTENSION')"
          class="info-box__error-message"
        />
        <div v-if="errors.size">
          {{ $t('image.ERROR_SIZE_MESSAGE') }}
          ({{ fileSizeMB }})<br />
          {{ $t('image.ERROR_SIZE_MAX', { n: maxAllowedSize }) }}
        </div>
      </div>

      <button class="info-box__choose-button" @click="chooseImage()">
        <div class="info-box__choose-button-container">
          <img
            v-if="isPreviewImage"
            :src="previewImage"
            class="info-box__choose-button-icon"
            alt=""
          />
          <img
            v-else
            :src="journeyDescriptionImage"
            alt=""
            class="info-box__choose-button-icon"
            role="presentation"
          />
        </div>

        <div class="info-box__choose-button-link">
          {{ $t('image.CHOOSE_IMAGE') }}
        </div>
        <div class="info-box__choose-button-description">
          {{ $t('image.DRAG_DROP') }}
        </div>
      </button>
    </div>
  </div>
</template>

<script>
import { journeyDescriptionImage } from '@/assets/img'

export default {
  props: {
    previewImage: {
      type: String,
      required: false,
      default: '',
    },
    errors: {
      type: Object,
      required: false,
      default: null,
    },
    fileSizeError: {
      type: Number,
      required: true,
    },
    maxAllowedSize: {
      type: String,
      required: true,
    },
    isDraggedOverDrop: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  emits: ['onOpenFileExplorer', 'onOpenUnsplash'],
  data() {
    return {
      journeyDescriptionImage,
    }
  },
  computed: {
    isPreviewImage() {
      return this.previewImage && !this.hasErrors
    },
    fileSizeMB() {
      return `${(this.fileSizeError / 1000000).toFixed(2)} MB`
    },
    hasErrors() {
      return this.errors !== null
    },
  },
  methods: {
    chooseImage() {
      this.$emit('onOpenFileExplorer')
    },
    openUnsplash() {
      this.$emit('onOpenUnsplash')
    },
  },
}
</script>

<style lang="scss" scoped>
.info-box {
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: $spacing-m;
  height: 100%;
  padding: $spacing-xs;

  @media screen and (max-width: $medium-desktop-width-max) {
    gap: $spacing-3xs;
  }

  &__error {
    position: absolute;
    top: 0;
    left: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: $spacing-3xs;
    padding: $spacing-4xs;
    width: 100%;
    font-size: $font-size-s;
    background: $color-red-05;
    border-radius: $border-radius-l $border-radius-l 0 0;
    border-bottom: 1px solid $color-border;
    color: $color-error;
  }

  &__choose-button {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    background: none;
    border-radius: $border-radius-l;
    padding: $spacing-3xs;
    border: 1px solid transparent;
    cursor: pointer;

    &:hover {
      border-color: $color-navigation;
    }

    &:active {
      background: $color-blue-10;
    }
  }

  &__choose-button-container {
    display: flex;
    align-items: flex-start;
    justify-content: center;
    width: 105px;
    height: 105px;
    border-radius: 50%;
    overflow: hidden;
    margin-bottom: $spacing-2xs;
    background-color: $color-blue-10;
    border: 1px solid $color-border;
  }

  &__choose-button-icon {
    object-fit: cover;
    width: inherit;
    height: inherit;
  }

  &__choose-button-link {
    @include subtitle-2;
    color: $color-link;
    margin-bottom: $spacing-4xs;
  }

  &__choose-button-description {
    color: $color-text-light;
  }
}

.info-box--dragged-over-drop {
  .info-box__choose-button-icon {
    animation: wiggle 800ms forwards;
  }
}

@keyframes wiggle {
  0% {
    transform: rotate(0deg) scale(1);
  }
  30% {
    transform: rotate(5deg) scale(1.2);
  }
  70% {
    transform: rotate(-2deg) scale(1.2);
  }
  100% {
    transform: rotate(0deg) scale(1.2);
  }
}
</style>
